document.addEventListener('DOMContentLoaded', () => {
  const breakpoint = window.matchMedia('(max-width: 989px)');
  const menuItems = document.querySelectorAll('.js-values__menu-item');
  const menuLinks = document.querySelectorAll('.js-values__menu-link');
  const contentItems = document.querySelectorAll('.js-values__content-item');
  const contentItemsMobile = document.querySelectorAll('.js-values__content-item-mobile');
  const menuItemActiveClass = 'values__menu-item--active';
  const contentItemActiveClass = 'values__content-item--active';
  const contentMobileActiveClass = 'values__item-text-wrap--mobile-active';

  setTimeout(() => {
    gsap.to('.js-values__item-image', { // Parallax like image
      yPercent: 25,
      ease: "none",
      scrollTrigger: {
        trigger: '.values',
        start: 'top top',
        end: "+=100%",
        scrub: true
      }
    });
  }, 100);

  const menuFirstItem = document.querySelector('.js-values__menu-link[data-menu-count="1"]').closest('.js-values__menu-item');
  const contentFirstItem = document.querySelectorAll('.js-values__content-item[data-content-count="1"]');
  if(menuFirstItem) menuFirstItem.classList.add(menuItemActiveClass);
  if(contentFirstItem) {
    contentFirstItem.forEach(el => {
      el.classList.add(contentItemActiveClass);
    })
  }
  if(breakpoint.matches) {
    const contentFirstItem = document.querySelector('.js-values__content-item-mobile[data-content-count="1"]');
    if(contentFirstItem) contentFirstItem.classList.add(contentMobileActiveClass);
    menuLinks && menuLinks.forEach(menu => {
      menu.addEventListener('click', e => {
        e.preventDefault();
        const count = e.currentTarget.dataset.menuCount;
        const parentMenu = e.currentTarget.closest('.js-values__menu-item');
        contentItemsMobile && contentItemsMobile.forEach(item => {
          if(!item) return;
          const inner = document.querySelector('.js-values__item-text-inner', item);
          const innerHeight = inner.clientHeight;
          const itemCount = item.dataset.contentCount;
          if(itemCount === count) {
            contentItemsMobile.forEach(el => {
              el.classList.remove(contentMobileActiveClass);
              el.style.maxHeight = 0;
            })
            menuItems && menuItems.forEach(itm => {
              itm.classList.remove(menuItemActiveClass);
            })

            item.classList.add(contentMobileActiveClass);
            item.style.maxHeight = `${innerHeight}px`;
            parentMenu.classList.add(menuItemActiveClass);
          }
        })
        contentItems && contentItems.forEach(item => {
          if(!item) return;
          const itemCount = item.dataset.contentCount;
          if(itemCount === count) {
            contentItems.forEach(el => {
              el.classList.remove(contentItemActiveClass);
            });
            item.classList.add(contentItemActiveClass);
          }
        });
      })
    })
  } else {
    menuLinks && menuLinks.forEach(menu => {
      menu.addEventListener('click', e => e.preventDefault());
      menu.addEventListener('mouseenter', e => {
        e.preventDefault();
        const count = e.currentTarget.dataset.menuCount;
        const parentMenu = e.currentTarget.closest('.js-values__menu-item');
        contentItems && contentItems.forEach(item => {
          if(!item) return;
          const itemCount = item.dataset.contentCount;
          if(itemCount === count) {
            menuItems && menuItems.forEach(itm => {
              itm.classList.remove(menuItemActiveClass);
            })
            contentItems.forEach(el => {
              el.classList.remove(contentItemActiveClass);
            });
            item.classList.add(contentItemActiveClass);
            parentMenu.classList.add(menuItemActiveClass);
          }
        })
      })
    })
  }
});